import { render, staticRenderFns } from "./echart-roster.vue?vue&type=template&id=58177fba&scoped=true&"
import script from "./echart-roster.vue?vue&type=script&lang=js&"
export * from "./echart-roster.vue?vue&type=script&lang=js&"
import style0 from "./echart-roster.vue?vue&type=style&index=0&id=58177fba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58177fba",
  null
  
)

export default component.exports